export default __webpack_public_path__ + "static/at&t-8bbcf4a9941e9106b16cfcb11681523f.png";